/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';

const MessageHandler = ({ error, success }) => (
  <div className="w-full flex justify-center">
    <p
      className={`${
        success
          ? 'text-center font-semibold  text-sm text-grey-dark'
          : 'text-pink text-center text-sm font-semibold'
      }`}
    >
      {success || error}
    </p>
  </div>
);

export default MessageHandler;
